import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './additem.css'; // Importing the CSS for styling
import WindowSelectorModal from './windows/WindowSelectorModal';
import PatioDoorSelectorModal from './patiodoors/PatioDoorSelectorModal';
import LibraryPickerDialog from './components/LibraryTemplates/LibraryPickerDialog';
import { useLibraryTemplates } from './utils/useLibraryTemplates';
import { WINDOWS_ENABLED, PATIO_DOORS_ENABLED, PLEATED_SCREENS_ENABLED } from './constants';
import { getCookie } from './utils/cookies';
import { useFeatures } from './utils/FeaturesContext';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

const AddItem = ({ quoteId, fkCustomerId, fkUserId, viewItem, pulse = false, onItemAdded }) => {
    const [contextMenu, setContextMenu] = useState(null);
    const navigate = useNavigate ();
    const [isWindowModalOpen, setWindowModalOpen] = useState(false);
    const [isPatioDoorModalOpen, setPatioDoorModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null); // Holds quoteId, fkCustomerId, etc.

    // Library picker dialog state: opened from the conditional "Add from the
    // library…" menu items. productType filters the picker to the matching kind.
    const [libraryPicker, setLibraryPicker] = useState({ open: false, productType: null });

    const { hasFeature } = useFeatures();
    // Per-product library counts decide whether the "Add from the library…"
    // menu item is shown. Each hook auto-refreshes on 'library-templates-updated'.
    // doorData.document.type values in this codebase are inconsistent:
    //   windows -> 'window' (singular), patio doors -> 'patiodoors' (plural),
    //   pleated screens -> 'pleatedscreens'.
    // Filter the user's library accordingly.
    const patioLibrary  = useLibraryTemplates('patiodoors');
    const windowLibrary = useLibraryTemplates('window');
    const screenLibrary = useLibraryTemplates('pleatedscreens');


    const handleClick = (event) => {
        event.stopPropagation();
        // Capture viewport coords for a position:fixed menu anchored just
        // above the click point (menu grows upward from the cursor).
        setContextMenu({
            mouseX: event.clientX,
            mouseY: event.clientY,
        });
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const handleMenuItemClick_old = (route) => {
        if (route === '/windows/WindowSelectorModal') {
            setModalOpen(true); // ✅ open modal
            handleClose();      // ✅ close context menu
            return;             // ✅ don't navigate
        }
        navigate(route, {
            state: { quoteId, fkCustomerId, fkUserId, viewItem }, // 👈 Pass quoteId via route state
        });
        handleClose();
    };

    const handleMenuItemClick = (route) => {
        if (route === '/windows/WindowSelectorModal') {
          setModalData({ quoteId, fkCustomerId, fkUserId, viewItem });
          setWindowModalOpen(true);
          handleClose();
          return;
        }

        if (route === '/patiodoors/PatioDoorSelectorModal') {
          setModalData({ quoteId, fkCustomerId, fkUserId, viewItem });
          setPatioDoorModalOpen(true);
          handleClose();
          return;
        }

        // Default route navigation
        navigate(route, {
          state: { quoteId, fkCustomerId, fkUserId, viewItem },
        });
        handleClose();
      };
      

    useEffect(() => {
        const handleOutsideClick = () => {
            handleClose();
        };

        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <div className="content-container1">
            {/*<h5 class="quote-heading">Quote Items</h5>*/}
            <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddIcon />}
                onClick={handleClick}
                className={pulse ? 'add-item-pulse' : ''}
                sx={{ fontWeight: 'bold', textTransform: 'none', mt: 1, mb: 1 }}
            >
                Add Item
            </Button>
            {contextMenu && (
                <ul
                    className="context-menu"
                    style={{
                        bottom: `${window.innerHeight - contextMenu.mouseY + 4}px`,
                        left: `${contextMenu.mouseX}px`,
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/*
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/entrydooreticom')}>Entry Door(Eticom)</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/patiodoor')}>Tilt and Turn Patio Door(Eticom)</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/pleatedscreen')}>Pleated Screen</li>
                    */}

                    {PATIO_DOORS_ENABLED && hasFeature('ALLOW_PATIO_DOORS') && (
                        <>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/patiodoors/pdt/pd1')}>Add Patio Door</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/patiodoors/PatioDoorSelectorModal')}>Add Predefined Patio Door...</li>
                    {patioLibrary.count > 0 && (
                      <li className="context-menu-item" onClick={() => { setLibraryPicker({ open: true, productType: 'patiodoors' }); handleClose(); }}>
                        Add Predefined Patio Door from My Library...
                      </li>
                    )}
                        </>
                    )}
                    {WINDOWS_ENABLED && hasFeature('ALLOW_WINDOWS') && (
                        <>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/windows/wint/w1')}>Add Window</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/windows/WindowSelectorModal')}>Add Predefined Window...</li>
                    {windowLibrary.count > 0 && (
                      <li className="context-menu-item" onClick={() => { setLibraryPicker({ open: true, productType: 'window' }); handleClose(); }}>
                        Add Predefined Window from My Library...
                      </li>
                    )}
                        </>
                    )}
                    {PLEATED_SCREENS_ENABLED && hasFeature('ALLOW_PLEATED_SCREENS') && (
                        <>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/pleatedscreenn')}>Add Pleated Screen</li>
                    {screenLibrary.count > 0 && (
                      <li className="context-menu-item" onClick={() => { setLibraryPicker({ open: true, productType: 'pleatedscreens' }); handleClose(); }}>
                        Add Predefined Pleated Screen from My Library...
                      </li>
                    )}
                        </>
                    )}
                    {/*<li className="context-menu-item" onClick={() => handleMenuItemClick('/ddd')}>Window</li>*/}
               </ul>
            )}
            {/* Window Selector Modal */}
            {isWindowModalOpen && (
            <WindowSelectorModal
                isOpen={true}
                onClose={() => setWindowModalOpen(false)}
                quoteId={modalData?.quoteId}
                fkCustomerId={modalData?.fkCustomerId}
                fkUserId={modalData?.fkUserId}
                viewItem={modalData?.viewItem}
            />
            )}

            {/* Patio Door Selector Modal */}
            {isPatioDoorModalOpen && (
            <PatioDoorSelectorModal
                isOpen={true}
                onClose={() => setPatioDoorModalOpen(false)}
                quoteId={modalData?.quoteId}
                fkCustomerId={modalData?.fkCustomerId}
                fkUserId={modalData?.fkUserId}
                viewItem={modalData?.viewItem}
            />
            )}

            {/* User library picker — opens the matching editor pre-loaded with the
                template's doorData. No ItemQuote is created until the user Saves
                in the editor; closing without saving creates nothing. */}
            <LibraryPickerDialog
                open={libraryPicker.open}
                productType={libraryPicker.productType}
                quoteId={quoteId}
                fkCustomerId={fkCustomerId}
                fkUserId={fkUserId}
                onClose={() => setLibraryPicker({ open: false, productType: null })}
            />

        </div>
    );
    
};

export default AddItem;
